import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, planCode, createCallback, invalidDataCallback, invalidPublicationDateCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      return [];
    }

    const fieldNames = [
      'Código de empleado',
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      'Código de empleado': yup.array().required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }


  const submit = async () => {
    if (await dataIsValid()) {
      const dataToSend = {
        "collaborators": formData['Código de empleado'],
        "planCode": planCode,
      };

      createCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    })
  }

  return { isCreate, formData, setFormValue, submit };
}

export default useHandleForm;
